var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ApiService/Notification.ts";
import * as t from 'io-ts';
import { Id, Version, BimReference, UserClassifierRepositoryFolder, UserClassifier, UserClassifierGroup, UserClassifierRepository, BaseClassifier, BimModel, AssemblyClassifier } from '@gmini/sm-api-sdk';
export var IncomingMessage = t.recursion('IncomingMessage', function () {
  return t.union([CreateEvent, InclusionStatusChangeEvent, UpdateEvent, RemoveEvent]);
});
export var CreateEvent = t.type({
  type: t.literal('CreateEvent'),
  payload: t.union([UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, UserClassifierRepository.io, BimReference.io, AssemblyClassifier.io])
});
export var InclusionStatusChangeEvent = t.type({
  type: t.literal('InclusionStatusChangeEvent'),
  payload: t.type({
    classifierId: Id,
    classifierVersion: Version
  })
});
export var UpdateEvent = t.type({
  type: t.literal('UpdateEvent'),
  payload: t.union([BaseClassifier.io, UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, BimReference.io, UserClassifierRepository.io, BimModel.io, AssemblyClassifier.io])
});
export var RemoveEvent = t.type({
  type: t.literal('RemoveEvent'),
  payload: t.union([UserClassifierRepositoryFolder.io, UserClassifier.io, UserClassifierGroup.io, UserClassifierRepository.io, BimReference.io, AssemblyClassifier.io])
});